<div data-cy="generic-info-modal__page">
    <div mat-dialog-title>
        <h2>
            {{ data.title }}
        </h2> 
    </div>
    
    <mat-dialog-content data-cy="generic-info-modal__dialog-content">
        <p [innerHTML]="data.body"></p>
    </mat-dialog-content>

    <mat-dialog-actions data-cy="generic-info-modal__dialog-actions" align="end" class="mt-20">
        <button data-cy="generic-info-modal__close-modal-btn" mat-stroked-button (click)="closeModal()">{{ 'close' | transloco }}</button>
    </mat-dialog-actions>
</div>